var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit, OnDestroy } from '@angular/core';
import { FooterComponent } from './footer.component';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import { takeWhile } from 'rxjs/operators';
import { INDRAFooterService } from '@ibe.services/footer.indra.service';
import { INDRAHeaderService } from '@ibe.services/header.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { ModalService } from '../modal/modal.indra.service';
import { Router } from '@angular/router';
import { INDRANavigateAwayModalComponent } from '@ibe.components/shared/navigate-away-modal/navigate-away-modal.indra.component';
import * as MiniIBEActions from '@ibe/store/actions/mini-ibe.actions';
import * as BookingStepsActions from '@ibe/store/actions/booking-steps.actions';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { DEFAULT_LANGUAGE, DEFAULT_MARKET, SESSION_VAR_KEY_LANGUAGE, SESSION_VAR_KEY_MARKET, SPECIAL_CASE_MARKET_LANGUAGE_MAP } from '@ibe.config';
var INDRAFooterComponent = /** @class */ (function (_super) {
    __extends(INDRAFooterComponent, _super);
    function INDRAFooterComponent(store, footerService, headerService, ibeAdminService, modalService, router, ibeAdminConfigService) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.footerService = footerService;
        _this.headerService = headerService;
        _this.ibeAdminService = ibeAdminService;
        _this.modalService = modalService;
        _this.router = router;
        _this.ibeAdminConfigService = ibeAdminConfigService;
        _this.showFallback = false;
        // private fallback_header$: Observable<boolean> = this.store.select(fromStore.getFallbackHeader);
        _this.isAlive = true;
        _this.milesBarHeight$ = _this.store.select(fromStore.getMilesBarHeight);
        _this.isCorporate$ = _this.store.select(fromStore.getIsCorporate);
        _this.bookingSteps = [];
        _this.booking_steps$ = _this.store.select(fromStore.getSelectedBookingSteps);
        _this.market$ = _this.store.select(fromStore.getUserMarket);
        _this.language$ = _this.store.select(fromStore.getUserLanguage);
        _this.footer = {
            SupportTitle: '',
            ListSupportLinks: [],
            UsefulLinksTitle: '',
            UsefulLinks: [],
            PromotionsCol1Title: '',
            PromotionsCol1Links: [],
            PromotionsCol2Links: [],
            FollowUsSectionTitle: '',
            ListSocialNetworks: [],
            TapAppSectionTitle: '',
            ListAppStoreButton: [],
            TapStopOverAppSectionTitle: '',
            ListStopOverAppStoreButton: [],
            NewsletterSectionTitle: '',
            NewsletterText: '',
            SubscribeNewsletter: null,
            BottomLinks: [],
            StarAllianceLink: null,
            StarAlianceIcon: '',
            Copyright: ''
        };
        _this.allSubscriptions = [];
        _this.INVALID_MARKET_MSG = 'Invalid Market.';
        _this.isFirstAccordionOpen = true;
        _this.isSecondAccordionOpen = false;
        _this.isThirdAccordionOpen = false;
        _this.SECTIONS = _this.INDRA_getFooterItems;
        /*
        this.fallback_header$
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(value => {
                this.showFallback = value;
            });
        */
        _this.milesBarHeight$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (milesBarHeight) { return _this.milesBarHeight = milesBarHeight; });
        // subscribe to language selected in the Market language component in the header
        if (!_this.showFallback) {
            _this.languageSubscription = _this.headerService.getLanguage().subscribe(function (lang) {
                _this.INDRA_getFooter(lang);
                _this.INDRA_loadFooterTranslations();
            });
            _this.allSubscriptions.push(_this.languageSubscription);
        }
        return _this;
    }
    INDRAFooterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.market$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (market) {
            var lang = sessionStorage.getItem('language');
            _this.INDRA_getFooter(lang);
            // Refresh footer links when market is changed
            _this.SECTIONS = _this.INDRA_getFooterItems;
        });
        this.language$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (language) {
            var lang = sessionStorage.getItem('language');
            _this.INDRA_getFooter(lang);
            // Refresh footer links when language is changed
            _this.SECTIONS = _this.INDRA_getFooterItems;
        });
        this.booking_steps$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.bookingSteps = value;
        });
        this.isCorporate$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value === true) {
                _this.isCorporate = true;
                _this.tapLogo = 'sprite.svg#logo--tap_corporate';
                _this.link = '/corporate';
            }
            else {
                _this.tapLogo = 'sprite.svg#logo--TAP-positive';
                _this.isCorporate = false;
                _this.link = '/booking';
            }
        });
    };
    INDRAFooterComponent.prototype.INDRA_getIBEAdminConfig = function (key) {
        var languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
            sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
        var languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
        var marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
            sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
        var urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
        var urlNavigate = urlIbeAdmin.replace('${lang}', "" + languageMap).replace('${market}', "" + marketCode);
        return urlNavigate;
    };
    INDRAFooterComponent.prototype.INDRA_handleToggle = function (section) {
        section.state = section.state === 'expanded' ? 'collapsed' : 'expanded';
    };
    INDRAFooterComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
        for (var _i = 0, _a = this.allSubscriptions; _i < _a.length; _i++) {
            var sub = _a[_i];
            if (sub) {
                sub.unsubscribe();
            }
        }
    };
    INDRAFooterComponent.prototype.INDRA_handleItemClick = function () {
        var _this = this;
        var activeBooking = this.bookingSteps.length > 0;
        if (activeBooking) {
            this.modalService.assignComponent(INDRANavigateAwayModalComponent);
            this.modalService.open();
            this.modalService.navigateAwaySelection$
                .pipe(takeWhile(function () { return _this.isAlive; }))
                .subscribe(function (value) {
                if (value) {
                    _this.store.dispatch(new MiniIBEActions.Reset());
                    _this.store.dispatch(new BookingStepsActions.ResetAction());
                    _this.router.navigate([_this.link]);
                }
            });
        }
        else {
            this.store.dispatch(new MiniIBEActions.Reset());
            this.router.navigate([this.link]);
        }
    };
    INDRAFooterComponent.prototype.INDRA_getLogo = function () {
        return this.tapLogo;
    };
    INDRAFooterComponent.prototype.INDRA_getFooter = function (lang) {
        var _this = this;
        if (lang != null) {
            this.footerSubscription = this.footerService.getFooter().subscribe(function (data) {
                // hides footer component if api error
                data.status == '200' ? _this.footerHasData = true : _this.footerHasData = false;
                if (data.status === '200' && data.footer) {
                    _this.footer = data.footer;
                    _this.footer.ListSocialNetworks = _this.INDRA_LoadStatic_ListSocialNetworks_Icons(data.footer.ListSocialNetworks);
                    _this.footer.ListAppStoreButton = _this.INDRA_LoadStatic_ListAppStoreButton_Svg(data.footer.ListAppStoreButton);
                    if (data.footer.ResponseStatus && data.footer.ResponseStatus.Description === _this.INVALID_MARKET_MSG) {
                        _this.showFallback = true;
                    }
                    else {
                        _this.showFallback = false;
                        _this.orderFooter();
                    }
                }
                else {
                    _this.showFallback = true;
                }
            }, function (err) {
                if (err) {
                    _this.showFallback = true;
                }
            });
            this.allSubscriptions.push(this.footerSubscription);
        }
    };
    INDRAFooterComponent.prototype.orderFooter = function () {
        if (this.footer.ListSupportLinks) {
            this.footer.ListSupportLinks.sort(this.compare);
        }
        if (this.footer.UsefulLinks) {
            this.footer.UsefulLinks.sort(this.compare);
        }
        if (this.footer.PromotionsCol1Links) {
            this.footer.PromotionsCol1Links.sort(this.compare);
        }
        if (this.footer.PromotionsCol2Links) {
            this.footer.PromotionsCol2Links.sort(this.compare);
        }
        if (this.footer.ListSocialNetworks) {
            this.footer.ListSocialNetworks.sort(this.compare);
        }
        if (this.footer.ListAppStoreButton) {
            this.footer.ListAppStoreButton.sort(this.compare);
        }
        if (this.footer.ListStopOverAppStoreButton) {
            this.footer.ListStopOverAppStoreButton.sort(this.compare);
        }
        if (this.footer.BottomLinks) {
            this.footer.BottomLinks.sort(this.compare);
        }
    };
    INDRAFooterComponent.prototype.compare = function (a, b) {
        if (a.Order < b.Order) {
            return -1;
        }
        else if (a.Order > b.Order) {
            return 1;
        }
        else {
            return 0;
        }
    };
    Object.defineProperty(INDRAFooterComponent.prototype, "bottomGapValue", {
        get: function () {
            return {
                'padding-bottom': this.milesBarHeight + 'px'
            };
        },
        enumerable: true,
        configurable: true
    });
    INDRAFooterComponent.prototype.INDRA_loadFooterTranslations = function () {
        var language = sessionStorage.getItem('language');
        if (language) {
            this.ibeAdminService.loadTranslations('tap', ['footer'], language);
        }
    };
    INDRAFooterComponent.prototype.INDRA_openUrl = function (url) {
        window.open(url);
    };
    INDRAFooterComponent.prototype.INDRA_toggleAccordionMenu = function (accordion) {
        switch (accordion) {
            case 'first':
                this.isFirstAccordionOpen = this.isFirstAccordionOpen ? false : true;
                break;
            case 'second':
                this.isSecondAccordionOpen = this.isSecondAccordionOpen ? false : true;
                break;
            case 'third':
                this.isThirdAccordionOpen = this.isThirdAccordionOpen ? false : true;
                break;
            default: break;
        }
    };
    /*
        replace Icons from response ex: data
        {
            "Order": 1,
            "Title": "Download TAP Air Portugal’s Android app here. This link opens in a new window.",
            "Text": "Download TAP Air Portugal’s Android app here. This link opens in a new window.",
            "Url": "https://play.google.com/store/apps/details?id=com.megasis.android&feature=search_result#?t=W251bGwsMSwxLDEsImNvbS5tZWdhc2lzLmFuZHJvaWQiXQ..",
            "Icon": "https://wcmsuatbo.tap.pt/-/media/Flytap/icons-general/Stores/google-play-badge_EN-US-01.ashx",
            "Target": "_blank"
        }
        to local files
        "Icon": "assets/header-footer/images/social/+ Text + _Footer.svg",

    */
    INDRAFooterComponent.prototype.INDRA_LoadStatic_ListSocialNetworks_Icons = function (socialNetworkList) {
        var path = 'assets/header-footer/images/social/';
        var list = socialNetworkList.map((function (item) {
            if (!item) {
                return item;
            }
            if (!item.Text) {
                return item;
            }
            if (!item.Icon) {
                return item;
            }
            var fileName = item.Text.charAt(0).toLocaleUpperCase() + item.Text.slice(1).toLowerCase();
            return __assign({}, item, { Icon: "" + path + fileName + "_Footer.svg" });
        }));
        return list;
    };
    INDRAFooterComponent.prototype.INDRA_LoadStatic_ListAppStoreButton_Svg = function (socialNetworkList) {
        var svg = 'sprite.svg#';
        var svgName = 'app-store--ios';
        var list = socialNetworkList.map((function (item) {
            if (!item) {
                return item;
            }
            if (!item.Text) {
                return item;
            }
            if (!item.Icon) {
                return item;
            }
            if (item.Icon.includes('google')) {
                svgName = 'app-store--android';
            }
            else {
                svgName = 'app-store--ios';
            }
            return __assign({}, item, { Icon: "" + svg + svgName });
        }));
        return list;
    };
    Object.defineProperty(INDRAFooterComponent.prototype, "INDRA_getFooterItems", {
        get: function () {
            return [
                {
                    label: 'footer.text.websites',
                    state: 'collapsed',
                    items: [
                        ['footer.text.flytap', this.INDRA_getIBEAdminConfig('externalURLs.footerFlytap')],
                        ['footer.text.institucional', this.INDRA_getIBEAdminConfig('externalURLs.footerInstitucional')],
                        ['footer.text.TAPCorporate', this.INDRA_getIBEAdminConfig('externalURLs.footerTAPCorporate')],
                        ['footer.text.TAPAirCargo', this.INDRA_getIBEAdminConfig('externalURLs.footerTAPAirCargo')],
                        ['footer.text.TAPMaintenanceEngineering', this.INDRA_getIBEAdminConfig('externalURLs.footerTAPMaintenanceEngineering')],
                        ['footer.text.TAPStore', this.INDRA_getIBEAdminConfig('externalURLs.footerTAPStore')]
                    ]
                },
                {
                    label: 'footer.text.importantResources',
                    state: 'collapsed',
                    items: [
                        ['footer.text.accessibility', this.INDRA_getIBEAdminConfig('externalURLs.footerAccessibility')],
                        ['footer.text.termsOfUse', this.INDRA_getIBEAdminConfig('externalURLs.footerTermsOfUse')],
                        ['footer.text.privacy', this.INDRA_getIBEAdminConfig('externalURLs.footerPrivacy')],
                        ['footer.text.conditionsOfCarriage', this.INDRA_getIBEAdminConfig('externalURLs.footerConditionsOfCarriage')]
                    ]
                },
            ];
        },
        enumerable: true,
        configurable: true
    });
    return INDRAFooterComponent;
}(FooterComponent));
export { INDRAFooterComponent };
